import { onMounted } from "vue";
import { templateRef } from "@vueuse/core";
import { useScrollTriggerAnimation } from "/composables/useScrollTriggerAnimation";


export default {
  __name: 'index',
  props: {
  dataProvider: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const { unveilText, reveal } = useScrollTriggerAnimation();
const tpl_titleWrapper = templateRef("tpl_titleWrapper");
const tpl_title = templateRef("tpl_title");
const tpl_tilesWrapper = templateRef("tpl_tilesWrapper");
const tpl_tiles = templateRef("tpl_tiles");

onMounted(() => {
  requestAnimationFrame(() => {
    unveilText(tpl_title.value, tpl_titleWrapper.value, "bottom", {
      textTarget: "words",
      intensity: "strong",
      stagger: "wide",
      duration: "normal",
    });

    reveal(tpl_tiles.value, tpl_tilesWrapper.value, "bottom", {
      intensity: "strong",
      fade: true,
      duration: "normal",
    });
  });
});

return { __sfc: true,props, unveilText, reveal, tpl_titleWrapper, tpl_title, tpl_tilesWrapper, tpl_tiles }
}

}